import { render, staticRenderFns } from "./UserNotificationForm.vue?vue&type=template&id=24d9b222&scoped=true"
import script from "./UserNotificationForm.vue?vue&type=script&lang=js"
export * from "./UserNotificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d9b222",
  null
  
)

export default component.exports